import { filterAbroadSelector } from '../../reducers/filter';

export const TOGGLE_FILTER_ABROAD = 'TOGGLE_FILTER_ABROAD';

export function ToggleFilterAbroad() {
    return (dispatch, getState) => {
        dispatch({
            type: TOGGLE_FILTER_ABROAD,
            payload: !filterAbroadSelector(getState()),
        });
    };
}
